<div class="header-container">
  <div class="logo-container">
    <div >
      <div
        *ngIf="logoCondition == 'first'; else elseBlock"
        class="header-images"
      >
        <a target="_blank" href="https://www.izervayecp.com/PatientSupport">
          <img
            src="/assets/images/izervay_header_logo.svg"
            class="circle-of-care-logo cursor-pointer"
          />
        </a>
        <!-- <img src="/assets/images/Line.png" alt="" class="header-textline mobile"/>
        <div class = "header-logo-text">
          Together With
          <p>GSK Oncology</p>
        </div>-->
      </div>

      <ng-template #elseBlock>
        <div class="header-images">
          <div class="d-flex align-items-center">
            <!-- <img
              *ngIf="!drawerOpen && blnShowLogout"
              src="/assets/images/Drawer.svg"
              class="drawer cursor-pointer"
              (click)="openSideNav()"
            /> -->
            <!-- <img
              *ngIf="drawerOpen"
              src="/assets/images/close-black.png"
              class="drawer cursor-pointer"
              (click)="
                $event.stopPropagation();
                drawerOpen = false;
                showHideMobileBackground.emit(drawerOpen)
              "
            /> -->
       
              <img
                src="/assets/images/izervay_header_logo.svg"
                class="circle-of-care-logo cursor-pointer"
                (click)="checkProgress('refresh')"
              />
            
            <div *ngIf="drawerOpen" class="drawer-content">
              <div>
                <span>
                  <img class="img-size" src="/assets/images/user-icon.svg" />
                </span>
                <span class="welcome-user-info">
                  <span
                    (click)="
                      checkProgress('profile');
                      drawerOpen = false;
                      showHideMobileBackground.emit(drawerOpen)
                    "
                    >Welcome {{ userCurrent }}</span
                  >
                </span>
              </div>
              <div class="logout-align">
                <div class="sign-out-logo">
                  <img class="logout-icon" src="../../../assets/images/logout-icon.svg" alt="logout-icon">
                </div>
                <span
                  (click)="
                    checkProgress('logout');
                    drawerOpen = false;
                    showHideMobileBackground.emit(drawerOpen)
                  "
                  >LogOut</span
                >
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <img
    src="/assets/images/Line.png"
    alt=""
    class="header-textline"
    [ngStyle]="{
      display: screenWidth <= 480 ? 'block' : 'none'
    }"
    *ngIf="logoCondition == 'first'"
  />

  <div
    class="healthcare health-professional-message"
    [ngStyle]="{ display: screenWidth <= 480 ? 'block' : 'none' }"
    *ngIf="logoCondition == 'first'"
  >
    <span>For U.S. Healthcare</span> <br /><span>Professionals Only</span>
  </div>

  <img
    src="/assets/images/Line.png"
    alt=""
    class="header-textline"
    [ngStyle]="{ display: screenWidth <= 480 ? 'block' : 'none' }"
    *ngIf="logoCondition == 'first'"
  />

  <div class="action-container pt-1">
    <div
      *ngIf="logoCondition == 'first'"
      class="health-professional-message logo-res"
    >
      <div
        class="healthcare"
        [ngStyle]="{ display: screenWidth <= 480 ? 'none' : 'block' }"
        *ngIf="this.router.url !=='/patient-esignature-authorization'"
      >
        <span>For U.S. Healthcare</span> <br /><span>Professionals Only</span>
      </div>
      <img
        src="/assets/images/Line.png"
        alt=""
        class="header-textline"
        [ngStyle]="{ display: screenWidth <= 480 ? 'none' : 'block' }"
        *ngIf="this.router.url !=='/patient-esignature-authorization'"
      />
      <span
        class="tooltip1 contact-no-details"
        *ngIf="logoCondition == 'first'"
      >
      <div class="alignment">
        <i class="fa fa-phone phone-icon"></i>&nbsp;
        <span class="header-phone-number">1-888-C5MYWAY</span>
      </div>
        <div class="header-phone-number-2 pb-1">(1-888-256-9929)</div>
        <div class="service-timings margin service-timings-2">
          8 AM ET to 8 PM ET
        </div>
      </span>
    </div>
    <ul *ngIf="logoCondition != 'first'" class="login-nav mt-2">
      <li class="centered-flex-right" style="width: 11.875rem; border-left: 0">
        <img
          src="/assets/images/Line.png"
          alt=""
          class="header-textline mobile"
        />
        <div>
          <span
            class="tooltip1 contact-no-details dashboard-contact mobile-contact"
          >
      <div class="alignment">

            <i class="fa fa-phone"></i>&nbsp;
            <span class="header-phone-number">1-888-C5MYWAY</span>
            </div>
            <div class="header-phone-number-2 pb-1">(1-888-256-9929)</div>
            <div class="service-timings margin service-timings-2">
              8 AM ET to 8 PM ET
            </div>
          </span>
        </div>
      </li>
      <li class="centered-flex" *ngIf="blnShowLogout">
        <div>
          <img class="img-size" src="/assets/images/user-icon.svg" />
        </div>
        <div class="welcome-user-info">
          <div>
            <span (click)="checkProgress('profile')"
              >Welcome {{ userCurrent }}</span
            >
          </div>
        </div>
      </li>
      <li class="centered-flex" *ngIf="blnShowLogout">
        <div class="logout-align">
          <div class="sign-out-logo">
            <img class="logout-icon" src="../../../assets/images/logout-icon.svg" alt="logout-icon">
          </div>
          <span (click)="checkProgress('logout')">LogOut</span>
        </div>
      </li>
    </ul>
  </div>
</div>

<p-dialog
  header="Reset Password"
  appendTo="body"
  [(visible)]="resetPassword"
  [contentStyle]="{ 'max-height': '80vh' }"
  [style]="{ width: '900px' }"
  [modal]="true"
  [baseZIndex]="10000"
  [responsive]="true"
  [resizable]="false"
  styleClass="customDialog resetPasswordDialog"
>
  <div class="reset-password">
    <div class="form">
      <form #adminReset="ngForm" (ngSubmit)="onAdminResetPassword(adminReset)">
        <div class="row">
          <div class="col-md-4" style="text-align: right; line-height: 46px">
            <label>User Name</label> <br />
            <label> New Password </label> <br />
            <label> Confirm Password</label>
          </div>
          <div class="col-md-8" style="position: relative">
            <input
              type="text"
              class="form-control"
              style="width: 200px"
              name="userCurrent"
              [(ngModel)]="userCurrent"
              id="userCurrent"
              required
              disabled
            />
            <br />
            <input
              type="password"
              class="form-control"
              style="width: 200px"
              name="adminPassword"
              [(ngModel)]="adminPassword"
              id="adminPassword"
              required
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,30}$"
              #adminPassword1="ngModel"
              (keyup)="checkpassword(adminPassword)"
              minlength="8"
              maxlength="30"
            />
            <br />
            <div
              style="width: 210px; position: absolute; top: 56px; left: 228px"
            >
              <ng-container *ngIf="adminPassword">
                <p
                  [ngClass]="{
                    'text-danger': !blnHasCapital,
                    'text-success': blnHasCapital
                  }"
                >
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-check-circle-o': blnHasCapital,
                      'fa-times-circle': !blnHasCapital
                    }"
                    aria-hidden="true"
                  ></i>
                  At least one upper case character
                </p>
                <p
                  [ngClass]="{
                    'text-danger': !blnLowerCase,
                    'text-success': blnLowerCase
                  }"
                >
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-check-circle-o': blnLowerCase,
                      'fa-times-circle': !blnLowerCase
                    }"
                    aria-hidden="true"
                  ></i>
                  At least one lower case character
                </p>
                <p
                  [ngClass]="{
                    'text-danger': !blnHasOneNumber,
                    'text-success': blnHasOneNumber
                  }"
                >
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-check-circle-o': blnHasOneNumber,
                      ' fa-times-circle': !blnHasOneNumber
                    }"
                    aria-hidden="true"
                  ></i>
                  At least one numeric digit
                </p>
                <p
                  [ngClass]="{
                    'text-danger': !blnHasSpecialChar,
                    'text-success': blnHasSpecialChar
                  }"
                >
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-check-circle-o': blnHasSpecialChar,
                      ' fa-times-circle': !blnHasSpecialChar
                    }"
                    aria-hidden="true"
                  ></i>
                  One non alphanumeric character between [!@#$%^&*]
                </p>
                <p
                  [ngClass]="{
                    'text-danger': !blnHasLength,
                    'text-success': blnHasLength
                  }"
                >
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-check-circle-o': blnHasLength,
                      'fa-times-circle': !blnHasLength
                    }"
                    aria-hidden="true"
                  ></i>
                  Password must be between 8 to 30 characters.
                </p>
              </ng-container>
            </div>
            <input
              type="password"
              class="form-control"
              style="width: 200px"
              name="adminConfirmPassword"
              [(ngModel)]="adminConfirmPassword"
              id="adminConfirmPassword"
              required
            />
            <div
              *ngIf="adminPassword !== adminConfirmPassword"
              class="error-message-newUser"
            >
              Password is not matching
            </div>
            <br />
            <button
              class="btn reset-password-btn"
              [disabled]="
                !adminReset.valid || adminPassword !== adminConfirmPassword
              "
            >
              Reset
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<!-- sidenav -->

<div
  [ngStyle]="{ display: showSidenav == true ? 'block' : 'none' }"
  class="sidenav-main" (click)="closeSideNav()"
> </div>
  <div class="sidenav" [ngStyle]="{ display: showSidenav == true ? 'block' : 'none' }">
    <div class="sidenav-header">
      <img
        class="sidenav-closebtn"
        src="../../../assets/images/close-black.png"
        (click)="closeSideNav()"
      />
        <img
          src="/assets/images/izervay_header_logo.svg"
          class="circle-of-care-logo-sidenav cursor-pointer"
        />
    </div>
    <div class="sidenav-body">
      <div class="sidenav-body-content">
        <img
          class="sidenav-body-content-img"
          src="../../../assets/images/user-icon.svg"
        />
        <span (click)="checkProgress('profile'); closeSideNav()"
          [ngStyle] = " sideNavMyProfile && {'color': '#006176'}"
          >My Profile</span
        >
      </div>

      <div class="sidenav-body-content">
        <img
          class="sidenav-body-content-img"
          src="../../../assets/images/Dashboard-darkTeal.png"
        />
        <span (click)="checkProgress('dashboard'); closeSideNav()"
        [ngStyle] = " sideNavDashboard && {'color': '#006176'} "
          >Dashboard</span
        >
      </div>

      <div class="sidenav-body-content">
        <img
          class="sidenav-body-content-img"
          src="../../../assets/images/MyPatient-DarkTeal.png"
        />
        <span (click)="checkProgress('myPatient'); closeSideNav()"
        [ngStyle] = " sideNavMyPatient && {'color': '#006176'} "
          >My Patients</span
        >
      </div>

      <div class="sidenav-body-content">
        <img
          class="sidenav-body-content-img"
          src="../../../assets/images/Tools-and-form-darkTeal.png"
        />
        <span (click)="checkProgress('toolsandforms'); closeSideNav()"
        [ngStyle] = " sideNavToolsAndForm && {'color': '#006176'} "
          >Tools and Forms</span
        >
      </div>

      <div class="sidenav-body-content">
        <img
          class="sidenav-body-content-img"
          src="../../../assets/images/Setting-darkTeal.png"
        />
        <span (click)="checkProgress('accountSettings'); closeSideNav()"
        [ngStyle] = " sideNavAccountSetting && {'color': '#006176'} "
          >Account Settings</span
        >
      </div>

      <div class="sidenav-body-content">
        <img
          class="sidenav-body-content-img"
          src="../../../assets/images/logout-icon-red.svg"
        />
        <span (click)="closeSideNav(); checkProgress('logout')">Logout</span>
      </div>
    </div>
  </div>
